const Home = () => (
    <svg
        version='1.1'
        id='Layer_1'
        xmlns='http://www.w3.org/2000/svg'
        x='0px'
        y='0px'
        viewBox='0 0 36 34'
        enableBackground='new 0 0 36 34'
        width='36'
        height='34'
    >
        <linearGradient
            id='SVGID_1_'
            gradientUnits='userSpaceOnUse'
            x1='1.6074'
            y1='17.3275'
            x2='34.0396'
            y2='17.3275'
            gradientTransform='matrix(1 0 0 -1 0 34)'
        >
            <stop offset='0' stopColor='#00A6FF' />
            <stop offset='1' stopColor='#00FFFF' />
        </linearGradient>
        <path
            fill='none'
            stroke='url(#SVGID_1_)'
            strokeWidth='2.89321'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M21.2,31.8H30V20.6v-1.4h1.4h1.7c0.3,0,0.6-0.1,0.8-0.3l0,0c0.4-0.4,0.4-1.1,0-1.5c0,0-16.1-15.9-16.1-15.9
	S1.8,17.4,1.8,17.4c-0.2,0.2-0.3,0.5-0.3,0.7c0,0.6,0.5,1,1.1,1h1.7h1.4v1.4v11.2h8.2v-7.3v-1.4h1.4h4.4h1.4v1.4V31.8z'
        />
    </svg>
);

export default Home;
